import { es } from 'date-fns/locale'
import { formatRelative } from 'date-fns'
import { add } from 'date-fns'

export default value => {
  return formatRelative(add(new Date(value), { hours: 5 }), new Date(), { locale: es })
}
